/*
 * The MRE requires support for WebGL2 (among other things), and provides its own
 * "support check" during `init()`. However, in order to send back as much information
 * as possible along with "MRE not supported" errors, it's also useful to know if
 * version 1 of WebGL is supported. Why? Because WebGL version 1 is sufficient for
 * mapbox-gl-js version 2.x, which is used by the existing web maps.
 */
export const isWebGLSupported = () => {
  try {
    const canvas = document.createElement('canvas');
    return !!(canvas.getContext && canvas.getContext('webgl'));
  } catch {
    return false;
  }
};
